module.exports = __webpack_public_path__ + "blackyogamat.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackyogamat.png
// module id = 874
// module chunks = 0